import {checkForRewards} from "../rewards/checkForRewards";

import {showComments} from "./showComments";
import {redirectToLogin} from "../utils/redirectToLogin";
import {showSubComments} from "./showSubComments";
import {enableSmilies} from "../utils/enableSmilies";
import {addComment} from "./addComment";
import {getCommunityType} from "../utils/getCommunityType";
import {getCommunityUserModal} from "../modal/getCommunityUserModal";

export function initComments() {

    $(document).on("click", ".more_comments_link", function (e) {
        e.preventDefault();
        let modal = $(this).closest(".js-comment-modal");
        let id = modal.attr("data-id");
        let container = $("#" + id);
        let tmpCommunityType = getCommunityType(container)
        let countComments = parseInt(container.find(".comment_count").text());
        if (shownComments[id] < countComments) {
            let commentsToLoad = countComments - count;
            if (commentsToLoad < 0) {
                count = count + commentsToLoad;
            }
            showComments(id, count, tmpCommunityType)
        }
    });
    $(document).on("click", ".js-show-comments", function (e) {
        e.preventDefault();
        if (shopUserId !== "") {
            let container = $(this).closest(".timeline_entry");
            let id = container.attr("id");

            let modal = document.querySelector('.js-comment-modal');
            const newModalId = 'commentModal_' + id;
            modal.setAttribute('id', newModalId);
            modal.setAttribute('data-id', id);
            modal.querySelector(".js-comments-container").innerHTML = "";
            let tmpCommunityType = getCommunityType(container)
            shownComments[id] = undefined
            showComments(id, count, tmpCommunityType);
            console.log(communityType);

            let newCommentRow = $(modal).find(".new_comment");
            let allCommentsTextAreas = $(modal).find("textarea");
            allCommentsTextAreas.val("");
            newCommentRow.find("img").attr("src", profileImageSrc);
            $(modal).modal("show");
            enableSmilies(newCommentRow.find("textarea"));

        } else {
            redirectToLogin();
        }
    });
    $(document).on("click", ".comment_comment_link", function (e) {
        e.preventDefault();
        let commentRow = $(this).closest(".display_comment");
        let commentCommentRow = commentRow.find(".comment_comments");
        let newCommentRow = commentRow.find(".new_comment_comment");
        let commentId = commentRow.attr("id").split("_")[1];
        if (commentCommentRow.hasClass("hidden")) {
            if (commentCommentRow.hasClass("not_viewed")) {
                showSubComments(commentId, count);
                commentCommentRow.removeClass("not_viewed");
                enableSmilies(newCommentRow.find("textarea"));
            }
            commentCommentRow.removeClass("hidden");
            newCommentRow.removeClass("hidden");
        } else {
            commentCommentRow.addClass("hidden");
            newCommentRow.addClass("hidden");
        }
    });
    $(document).on("click", ".display_comment a", function (e) {
        e.preventDefault();
        let clickedClassName = $(this).attr("class");
        if (clickedClassName === "name" || clickedClassName === "image") {
            let link = $(this).attr("href");
            let linkArray = link.split("/");
            let nickname = linkArray[linkArray.length - 2];
            let modal = $("#community_user_profile_modal_" + nickname);
            if (modal.length) {
                modal.modal("show");
            } else {
                getCommunityUserModal(nickname);
            }
        }
    });
    /* $(document).on("keypress", "textarea", function (e) {
         if (e.which == 13) {
             if (shopUserId !== "") {
                 let target = $(e.target);
                 if ((target.attr("class") === "input_comment smiley_input" || target.attr("class") === "input_comment_comment smiley_input") && !e.shiftKey) {
                     let id = $(this).closest(".timeline_entry").attr("id");
                     let parentId = 0;
                     let comment = $(this).val();
                     if (target.attr("class") === "input_comment_comment smiley_input") {
                         id = 0;
                         parentId = $(this).closest(".display_comment").attr("id").split("_")[1];
                     }

                     if (comment.trim() !== "") {
                         addComment(id, comment, parentId);
                         checkForRewards(1); // Check for Reward of type Comments
                     }
                 }
             } else {
                 redirectToLogin();
             }
         }
     });    */
    $(document).on("submit", ".js-new-comment-form", function (e) {
        e.preventDefault();
        if (shopUserId !== "") {
            let target = $(e.target);
            const newComment = target.find('[name="new_comment"]');
            const newCommentComment = target.find('[name="new_comment_comment"]');
            let id = target.closest(".js-comment-modal").attr("data-id");
            let parentId = 0;
            let comment;
            if (newComment) {
                comment = newComment.val();
            }
            if (newCommentComment && newCommentComment.val()) {
                comment = newCommentComment.val();
                id = 0;
                parentId = target.closest(".display_comment").attr("id").split("_")[1];
            }
            if (comment.trim() !== "") {
                addComment(id, comment, parentId);
                checkForRewards(1);
            }
        } else {
            redirectToLogin();
        }
    });
    $(document).on("keyup", "textarea", function (e) {
        if (!$('body').hasClass('account')) {
            if (shopUserId && shopUserId !== "") {
                let target = $(e.target);
                if (target.attr("class") === "input_comment smiley_input" || target.attr("class") === "input_comment_comment smiley_input") {
                    let max = 280;
                    if (target.val().length > max) {
                        target.val(target.val().substring(0, max));
                    }
                }
            } else {
                redirectToLogin();
            }
        }
    });
}